import { Dispatch } from "react"
import qs from "qs"

import http from "../../../http_comon"
import { IReportingImage, ISearchReportingImages, ReporingImageActionTypes, ReportingImageAction } from "./types"
import { ServerError } from "../../../store/types"


export const SearchReportingImage = (page: number, rowsPerPage: number) => {
    return async (dispatch: Dispatch<ReportingImageAction>) => {
        try {
            let response = await http.get<ISearchReportingImages>(`api/ReportingImage/Search`, {
                params: {
                    page: page,
                    rowsPerPage: rowsPerPage
                },
                paramsSerializer: params => {
                    return qs.stringify({ ...params })
                }
            })

            dispatch({
                type: ReporingImageActionTypes.SEARCH_REPORTING_IMAGES,
                payload: response.data
            })

            return Promise.resolve();
        }
        catch (error) {
            return Promise.reject(error as ServerError)
        }
    }
}

export const CreateReportingImage = (base64: string) => {
    return async (dispatch: Dispatch<ReportingImageAction>) => {
        try {
            let response = await http.post<IReportingImage>(`api/ReportingImage/Create`, base64)

            return Promise.resolve(response.data);
        }
        catch (error) {
            return Promise.reject(error as ServerError)
        }
    }
}

export const DeleteReportingImage = (id: number) => {
    return async (dispatch: Dispatch<ReportingImageAction>) => {
        try {
            await http.delete(`api/ReportingImage/Delete/${id}`)

            return Promise.resolve();
        }
        catch (error) {
            return Promise.reject(error as ServerError)
        }
    }
}
